import React from "react";
import arrow from "../../../resources/arrow.svg";
import "./Blog.css";

function Blog({ title, subtitle, img }) {
  return (
    <div className="homeSectionFiveBlog">
      <div className="homeSectionFiveBlog--container">
        <div className="homeSectionFiveBlog__img">
          <img src={img} />
        </div>
        <div className="homeSectionFiveBlog__info">
          <div className="homeSectionFiveBlog--title">
            <h4>{title}</h4>
          </div>
          <div className="homeSectionFiveBlog--subtitle">
            <p>{subtitle}</p>
          </div>

          <div className="homeSectionFiveBlog--readMore">
            <p>Read More </p>
            <span>
              <img src={arrow} />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Blog;
